/**
 * This is required for mui v5 as it seems we can't yet rely
 * on automatic ssr hydration offered by emotion 11.
 */
import createCache, { EmotionCache } from '@emotion/cache';

export const createEmotionCache = (): EmotionCache => {
  return createCache({ key: 'css' });
};
